import { render, staticRenderFns } from "./DetalleComprobacionAMEX.vue?vue&type=template&id=2514076a&scoped=true&"
import script from "./DetalleComprobacionAMEX.vue?vue&type=script&lang=js&"
export * from "./DetalleComprobacionAMEX.vue?vue&type=script&lang=js&"
import style0 from "./DetalleComprobacionAMEX.vue?vue&type=style&index=0&id=2514076a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514076a",
  null
  
)

component.options.__file = "DetalleComprobacionAMEX.vue"
export default component.exports